<template>
        <div class="fixed">
                <div class="fixItem" @click="goOne()"><img src="../assets/image/topItem.png" alt="" ><div class="fixText">{{$t('language.top')}}</div></div>
                <!-- <div class="fixItem" @click="shop()"><img src="../assets/image/shopItem.png" alt=""><div class="fixText">{{$t('language.mall')}}</div></div> -->
                <div class="fixItem" @click="weibo()"><img src="../assets/image/weiboItem.png" alt=""><div class="fixText">{{$t('language.weibo')}}</div></div>
                <div class="fixItem" @click="weChat()"><img src="../assets/image/weChatItem.png" alt=""><div class="fixText">{{$t('language.WeChat')}}</div></div>
        </div>
</template>
<script>
export default {
    props: {
      goTop: {
        type: Function,
        default: null
      }
    },
    name:'fixed',
    data(){
        return{
            shop_link: '',
            wechat_link: '',
            weibo_link: '',
        }
    },
    mounted(){
      this.getInfo();
    },
    methods:{
        getInfo(){
            this.$fetch('/index/info').then(res => {
                console.log(res.data)
                this.shop_link = res.data.shop_link;
                this.wechat_link = res.data.wechat_link;
                this.weibo_link = res.data.weibo_link;
            })
        },
       //回到顶部
       goOne(){
            if(this.goTop){
               this.goTop();
            }
       },
       // 跳转到商城
       shop(){
           this.$router.push({
               path:'/ShoppingMall'
           })
       },
       //跳转到微博
       weibo(){
          window.location.href = this.weibo_link;
       },
       //跳转到微信
       weChat(){
          window.location.href = this.wechat_link;
       }
    }
}
</script>
<style scoped>
.fixed{
    position: fixed;
    right: 86px;
    bottom: 90px;
    transition: all 1s;
    opacity: 0;
}
.fixItem{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    /* background: #020101; */
    color: #020101;
    margin-top: 8px;
}
.fixItem:nth-of-type(1){
    background: #000000;
    color: #FFFFFF;
}
.fixItem:nth-of-type(4){
    margin-top: 16px;
}
.fixItem>img{
    width:28px;
    height: 28px;
}
.fixText{
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    margin-top: 3px;
}
</style>   


// WEBPACK FOOTER //
// src/components/fixed.vue